var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreVertical = function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.833 10a.833.833 0 1 0-1.666 0 .833.833 0 0 0 1.666 0M5 10a.833.833 0 1 0-1.666 0A.833.833 0 0 0 5 10M16.667 10A.833.833 0 1 0 15 10a.833.833 0 0 0 1.667 0"
  })));
};
export default SvgMoreVertical;